import GwBrowse from "./browse";

export { GwBrowse };

export default GwBrowse;
